import { IBreadcrumbItems } from '@shared/models/components/IBreadcrumb';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { CommonRowWrapper } from '../layouts/CommonLayoutStyles';
import Breadcrumb from '../structure/Breadcrumb';
import { Tag } from '../text/ContentTypography';
import { BodySmall, DisplaySmall, LightSmall } from '../text/Typography';
import { HeaderChildWrap, HeaderTextWrap } from './CommonHeaderStyles';

export interface IPageHeaderProps {
    title: string | React.ReactNode;
    description?: string;
    children?: React.ReactNode;
    prefix?: string;
    tag?: string;
    items?: IBreadcrumbItems[];
    licenseTag?: React.ReactNode;
}

export default function PageHeader({
    title = '',
    description,
    children,
    prefix,
    tag,
    items,
    licenseTag,
}: IPageHeaderProps) {
    const { t } = useTranslation('common');
    const { managedOrgId } = useParams();
    if (managedOrgId) tag = t('organization.managed.titleShort');

    return (
        <>
            {items && <Breadcrumb items={items} />}
            <CommonRowWrapper>
                <HeaderTextWrap>
                    {prefix && <LightSmall>{prefix}</LightSmall>}
                    {tag && <Tag>{tag}</Tag>}
                    {licenseTag}
                    {typeof title == 'string' ? <DisplaySmall as="h1">{title}</DisplaySmall> : title}
                    {description && <BodySmall>{description}</BodySmall>}
                </HeaderTextWrap>
                {children && <HeaderChildWrap>{children}</HeaderChildWrap>}
            </CommonRowWrapper>
        </>
    );
}
